module.exports = __webpack_public_path__ + "img/logo_sistema_diagnostico.6bc75142.jpg";